import { initContract } from '@ts-rest/core';
import { z } from 'zod';

export const c = initContract();

export const booleanQueryParam = z.union([
  z.boolean(),
  z.enum(['true', 'false']).transform((value) => value === 'true'),
]);
